import { useRef } from "react";
import { Palette, Code2, MessageSquareText, RefreshCw, TrendingUp } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const SERVICES = [
  { icon: Palette, title: "Web Design", desc: "Modern, premium websites designed around your brand and customers." },
  { icon: Code2, title: "Web Development", desc: "Fast, responsive and technically polished websites built for performance." },
  { icon: MessageSquareText, title: "Enquiry Systems", desc: "Focused forms and customer journeys designed to generate valuable enquiries, quote requests and booking requests." },
  { icon: RefreshCw, title: "Website Redesigns", desc: "Transform outdated websites into modern digital experiences." },
  { icon: TrendingUp, title: "Conversion Optimisation", desc: "Strategic layouts and experiences designed to generate more qualified enquiries and direct contact." },
];

const ServiceCard = ({ service, i }) => {
  const ref = useRef(null);
  const Icon = service.icon;

  const onMove = (e) => {
    const el = ref.current;
    if (!el || window.innerWidth < 768) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(900px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg) translateZ(0)`;
  };
  const onLeave = () => {
    if (ref.current) ref.current.style.transform = "perspective(900px) rotateY(0deg) rotateX(0deg)";
  };

  return (
    <Reveal i={i} className="h-full">
      <div
        ref={ref}
        data-testid={`service-card-${i}`}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className="group relative h-full rounded-3xl glass p-8 transition-[background-color,border-color] duration-500 hover:bg-white/[0.07] hover:border-white/25 will-change-transform"
        style={{ transition: "transform 0.35s ease, background-color 0.5s, border-color 0.5s" }}
      >
        <div className="absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-white/15 bg-white/5 text-white/80 group-hover:text-white group-hover:border-white/30 transition-colors duration-500">
          <Icon size={20} strokeWidth={1.5} />
        </div>
        <h3 className="font-display mt-7 text-xl font-semibold tracking-tight text-white">{service.title}</h3>
        <p className="mt-3 text-sm font-light leading-relaxed text-white/50">{service.desc}</p>
        <span className="font-display mt-6 block text-[10px] tracking-[0.35em] text-white/25 group-hover:text-white/60 transition-colors duration-500">
          0{i + 1}
        </span>
      </div>
    </Reveal>
  );
};

const Services = () => (
  <section id="services" data-testid="services-section" className="relative z-10 py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <SectionHeading
        kicker="Services"
        title="Everything Your Business Needs To Launch."
        sub="From first concept to a fully launched digital presence — every detail designed, engineered and polished in-house."
        testId="services-heading"
      />
      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.title} service={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Services;
